import { buttonClass } from '@league/ui';

/**
 * "PRINT SCORE SHEET" — the league's generic sheet (owner, 2026-10-15, Courtney): no table number,
 * week or names printed, so any sheet serves any table and a spilled one is swapped for another. Its
 * QR opens tonight's session and the player picks their table. Nothing on it depends on a session or on
 * seating, so it always prints — the per-session version could refuse ("Check the seating first")
 * on a session whose scores were already approved, which made no sense to anybody.
 *
 * A plain link to the PDF, opened in a new tab with its own name, to look at before printing.
 */
export function PrintScoreSheets({ leagueId }: { leagueId: string; /** Accepted for old callers; there is only the button. */ variant?: 'button' }) {
  return (
    <a
      href={`/api/leagues/${encodeURIComponent(leagueId)}/score-sheet.pdf`}
      target="_blank"
      rel="noopener"
      className={buttonClass('secondary')}
    >
      Print score sheet
    </a>
  );
}
